import * as React from 'react';
import { AEMContent, Card } from '@mlc/web-ui-toolkit';
import styled from 'styled-components';

const Help: React.FunctionComponent = () => (
	<Card marginTop={9}>
		<StyleWrapper>
			<AEMContent path="/secure/_content/Adviser/epi/need-help" />
		</StyleWrapper>
	</Card>
);

export default Help;

const StyleWrapper = styled.div`
	h2 {
		font-size: 26px;
		font-weight: 500;
		color: #181816;
	}
`;
